<template>
  <div>
    <van-cell title="收款账号" is-link value="添加收款账号" @click="addEdit('0')" />
    <div class="account-list" v-for="(item, index) in list" :key="index">
      <div class="a-li" @click="addEdit(item)">
        <van-cell :title="'姓名：'+item.name" is-link :value="item.type_name" />
        <div class="a-l-li">
          <span>卡号：{{ item.account_no }}</span>
          <span>手机号：{{ item.tel }}</span>
        </div>
      </div>
    </div>

    <van-dialog v-model="show" :title="dialogTitle" show-cancel-button :before-close="beforeClose">
      <!--
      <van-field name="radio" label="收款方式">
        <template #input>
          <van-radio-group v-model="info.type" direction="horizontal">
            <van-radio name="1">微信</van-radio>
            <van-radio name="2">支付宝</van-radio>
            <van-radio name="3">银行卡</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      -->
      <van-field
        readonly
        clickable
        name="picker"
        :value="info.bank_name"
        label="收款银行"
        placeholder="请选择收款银行"
        @click="showPicker = true"
      />
      <van-field
        v-model="info.name"
        name="姓名"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="info.account_no"
        name="卡号"
        label="卡号"
        placeholder="请输入银行卡号"
        :rules="[{ required: true, message: '请输入银行卡号' }]"
      />
      <van-field
        v-model="info.tel"
        type="tel"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
    </van-dialog>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Form, Dialog, RadioGroup, Radio, Cell, CellGroup, Picker, Popup } from 'vant';

  export default {
    components: {
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Dialog.Component.name]: Dialog.Component,
      Form
    },
    name: 'accountList',
    data() {
      return {
        show: false,
        showPicker: false,
        dialogTitle: '添加收款账号',
        list: [],
        total: 0,
        info: {
          id: 0,
          type: '3',
          tel: '',
          name: '',
          account_no: '',
          bank_name: '',
        },
        columns: ['中国工商银行', '中国农业银行', '中国建设银行', '中国邮政储蓄银行', '中国人民银行', '招商银行'],
      };
    },
    created() {
      this.getAccountList()
    },
    methods: {
      getAccountList() {
        this.$api.get('account/index', null, r=>{
          r.data.map((item, index)=>{
            if(item.type === 1){
              item.type_name = '微信'
            }else if(item.type === 2){
              item.type_name = '支付宝'
            }else if(item.type === 3){
              item.type_name = '银行卡'
            }
          })
          this.list = r.data
          this.total = this.list.length
        })
      },
      onConfirm(value) {
        this.info.bank_name = value;
        this.showPicker = false;
      },
      addEdit(account) {
        if(account === '0'){
          if(this.total < 5){
            this.dialogTitle = '添加收款账号'
            this.show = true
          }else{
            this.$toast('收款账号最多可添加5个')
          }
        }else{
          this.dialogTitle = '编辑收款账号'
          this.info = account
          this.info.bank_name = String(account.bank_name)
          this.show = true
        }
      },
      beforeClose : function (action, done) { // 点击事件 - 备注按钮提示框
        if (action === 'confirm') { // 确认
          if(this.info.bank_name == ''){
            this.$toast('请选择收款银行')
            done(false);
            return
          }
          if(this.info.name == ''){
            this.$toast('请输入姓名')
            done(false);
            return
          }
          if(this.info.account_no == ''){
            this.$toast('请输入银行卡号')
            done(false);
            return
          }
          if(this.info.tel == ''){
            this.$toast('请输入手机号')
            done(false);
            return
          }
          if(this.info.id === 0){
            // 添加
            this.$api.post('account/store', this.info, r=>{
              if(r.success === 1){
                this.$toast('添加成功')
                window.location.reload()
              }
            })
          }else{
            // 更新
            this.$api.post('account/update', this.info, r=>{
              if(r.success === 1){
                this.$toast('更新成功')
                window.location.reload()
              }
            })
          }
          done();
        } else if (action === 'cancel') { // 取消
          this.info.id = 0
          this.info.type = '3'
          this.info.name = ''
          this.info.account_no = ''
          this.info.tel = ''
          this.info.bank_name = ''
          this.getAccountList()
          done();
        }
      },
    },
  }
</script>

<style scoped>
  .account-list{
    margin-top: 10px;
  }
  .account-list .a-li{
    overflow: hidden;
    border-bottom: 1px solid #ece3e3;
  }
  .account-list .a-li:last-child{
    border-bottom: none;
  }
  .account-list .a-l-li{
    font-size: 14px;
    overflow: hidden;
    background: #ffffff;
    padding:5px 15px 10px;
  }
  .account-list .a-l-li span{
    display: inline-block;
    width: 49%;
    line-height: 23px;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/accountList.vue